import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function showSidebarIzquierdaReducer(state= initialState.showSidebarIzquierda, action){
	
	switch(action.type){
		case types.ON_SHOW_SIDEBAR_IZQUIERDA:	            
			return action.datos;
		//break;		
	
		default:
			return state;
	}
}